// extracted by css-extract-rspack-plugin
export default {"canceledText":"ContractSendStatusColumn__canceledText--zHtIK"};